<template>
  <div class="home-page">
    <main class="home">
      <div class="container home__container">
        <section class="home-hero" aria-labelledby="home-title">
          <h1 id="home-title" class="home-hero__heading">Мегабонус</h1>
          <p class="home-hero__subheading">
            Участвуй в акциях, выполняй задания,<br />
            копи бонусы и обменивай их на товары
          </p>

          <div class="home-links">
            <a
              class="home-links__btn home-links__btn--filled"
              @click="sideMenu('catalog')"
            >
              Каталог товаров
            </a>
            <router-link class="home-links__btn" to="/instructions">
              Пройти инструктаж
            </router-link>
          </div>
        </section>

        <section class="mission" aria-labelledby="mission-title">
          <div class="mission__content">
            <h2 id="mission-title" class="mission__title">Наша миссия:</h2>
            <p class="mission__text">
              Мы дарим уверенность на дороге и радость<br
                class="mission__desktop-break"
              />
              от сервиса, в который <span>хочется вернуться.</span>
            </p>
          </div>
        </section>

        <div class="fitlab-section">
          <section class="fitlab-banner" aria-labelledby="fitlab-banner-title">
            <div
              class="fitlab-banner__photo"
              role="img"
              aria-label="Сотрудница ФИТ Академии изучает материалы на планшете"
            ></div>
            <div class="fitlab-banner__grid" aria-hidden="true"></div>
            <img
              class="fitlab-banner__logo"
              src="../assets/images/fitlab/fitlab-logo.svg"
              alt="FIT LAB — центр обучения и развития"
            />
            <img
              class="fitlab-banner__heart"
              src="../assets/images/fitlab/fitlab-heart.svg"
              alt=""
              aria-hidden="true"
            />

            <div class="fitlab-banner__offer">
              <h2 id="fitlab-banner-title">
                Зарабатывай мегабонусы на ФИТ Академии
              </h2>
              <div class="fitlab-banner__actions">
                <a
                  class="fitlab-banner__button fitlab-banner__button--primary"
                  href="https://myfitautolab.ru/fitlab57"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ФИТ АКАДЕМИЯ
                </a>
                <a
                  class="fitlab-banner__button"
                  href="https://clck.ru/3Sd2Fy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Чат ФИТ АКАДЕМИЯ
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>

      <div class="home-notifications">
        <transition-group name="notification" tag="div">
          <div
            v-for="notification in notificationsToDisplay"
            :key="notification.id"
          >
            <notification-card
              :item="notification"
              @open="openNotificationModal"
              @close="closeNotification"
            />
          </div>
        </transition-group>
      </div>

      <notification-modal
        v-if="isModalVisible"
        :item="selectedNotification"
        :visible="isModalVisible"
        @close="closeNotificationModal"
      />
    </main>
  </div>
</template>

<script>
import { EventBus } from "@/main.js";
import { io } from "socket.io-client";
import { jwtDecode } from "jwt-decode";
import NotificationCard from "../components/Notifications/NotificationCard.vue";
import NotificationModal from "../components/Notifications/NotificationModal.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    NotificationCard,
    NotificationModal,
  },

  data() {
    return {
      notifications: new Map(),
      visibleNotifications: new Map(),
      // Keep this variable in sync with visibleNotifications (Vue 2 does not
      // observe Map mutations reliably).
      notificationsToDisplay: [],
      maxVisibleNotifications: 3,
      isOpen: false,
      isModalVisible: false,
      selectedNotification: null,
    };
  },

  computed: {
    ...mapGetters(["isModalOpen"]),
  },

  created() {
    const decodedToken = jwtDecode(localStorage.getItem("jwt"));

    this.socket = io(process.env.VUE_APP_baseURL, {
      query: {
        userId: decodedToken.id,
        unreadNotifIdOffset: Number(localStorage.getItem("lastUnreadNotifId")),
      },
    });

    this.socket.on("notification", (data) => {
      this.notifications.set(data?.id, data);
      this.updateVisibleNotifications();
      this.socket.emitWithAck("read-notification", data?.id);
      localStorage.setItem("lastUnreadNotifId", data?.id);
    });

    this.socket.on("get-unread-notifications", (notifications, lastNotifId) => {
      notifications.forEach((notification) => {
        this.socket.emitWithAck("read-notification", notification?.id);
        if (notification.id > lastNotifId) {
          this.notifications.set(notification.id, notification);
        }
      });
      localStorage.setItem("lastUnreadNotifId", lastNotifId);
      this.updateVisibleNotifications();
    });
  },

  beforeDestroy() {
    if (this.socket) {
      this.socket.disconnect();
    }
  },

  methods: {
    ...mapActions(["openModal", "closeModal", "toggleModal"]),

    updateVisibleNotifications() {
      const remainingSlots =
        this.maxVisibleNotifications - this.visibleNotifications.size;
      const nextNotifications = [...this.notifications.values()].slice(
        0,
        remainingSlots,
      );

      nextNotifications.forEach((notification) => {
        this.notifications.delete(notification.id);
        this.visibleNotifications.set(notification.id, notification);
      });

      this.notificationsToDisplay = [...this.visibleNotifications.values()];
    },

    closeNotification(id) {
      this.visibleNotifications.delete(id);
      this.notifications.delete(id);
      this.updateVisibleNotifications();
    },

    sideMenu(menuClicked) {
      this.isOpen = true;
      EventBus.$emit("menuClicked", { menuClicked, isOpen: true });
    },

    openNotificationModal(item) {
      this.openModal("notificationModal");
      this.selectedNotification = item;
      this.isModalVisible = true;
    },

    closeNotificationModal() {
      this.closeModal("notificationModal");
      this.isModalVisible = false;
      this.selectedNotification = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.notification-enter-active,
.notification-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}

.notification-enter,
.notification-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.home-page {
  position: relative;
  z-index: 1;
}

.home {
  position: relative;
  z-index: 12;
  min-height: calc(100vh - 198px);
  overflow: hidden;
  background: #1a1c1c;

  &__container {
    width: 100%;
    max-width: none;
    padding: 0;
  }
}

.home-hero {
  width: calc(100% - 64px);
  max-width: 1312px;
  margin: 0 auto;
  padding: 213px 0;

  &__heading {
    margin: 0;
    color: #fff;
    font-family: $roboto;
    font-size: clamp(48px, 5vw, 96px);
    font-weight: 700;
    line-height: 1;
    letter-spacing: -2.3px;
    text-transform: uppercase;
  }

  &__subheading {
    max-width: 564px;
    margin-top: 32px;
    color: #fff;
    font-family: $roboto;
    font-size: clamp(18px, 1.25vw, 24px);
    font-weight: 400;
    line-height: 1;
  }
}

.home-links {
  display: flex;
  gap: 12px;
  margin-top: 32px;

  &__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 210px;
    height: 52px;
    padding: 0 24px;
    border: 1px solid #fff;
    border-radius: 4px;
    color: #fff;
    font-family: $fact;
    font-size: clamp(16px, 0.833vw, 16px);
    font-weight: 500;
    line-height: 20px;
    cursor: pointer;
    transition: background-color 0.2s ease, border-color 0.2s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.08);
    }

    &--filled {
      border-color: #fe5000;
      background: #fe5000;

      &:hover {
        border-color: #e93f00;
        background: #e93f00;
      }
    }
  }
}

.mission {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 72px 0;
  background: #000;

  &__content {
    display: flex;
    flex-direction: column;
    gap: 43px;
    width: calc(100% - 64px);
    max-width: 1368px;
    margin: 0 auto;
  }

  &__title {
    margin: 0;
    color: #fff;
    font: 400 clamp(18px, 1.25vw, 24px) / 17px $roboto;
  }

  &__text {
    width: 100%;
    max-width: 1236px;
    margin: 0;
    color: #fff;
    font-family: $fact;
    font-size: clamp(28px, 2.5vw, 48px);
    font-weight: 700;
    line-height: clamp(32px, 2.708vw, 52px);
    font-feature-settings: "tnum" on, "lnum" on;

    span {
      color: #fe5000;
    }
  }
}

.fitlab-section {
  padding: 108px 0;
}

.fitlab-banner {
  position: relative;
  width: calc(100% - 64px);
  max-width: 1368px;
  aspect-ratio: 1368 / 477;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 16px;
  background: #bbaa91;

  &__photo {
    position: absolute;
    top: 0;
    right: 0;
    width: 60.819%;
    height: 100%;
    background: url("../assets/images/fitlab/academy-banner-desktop.webp") center
      center / cover no-repeat;
  }

  &__grid {
    position: absolute;
    top: 8.386%;
    left: 2.924%;
    width: 94.152%;
    height: 83.229%;
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    background: url("../assets/images/fitlab/fitlab-grid.svg") 0 0 /
      calc(100% / 13) calc(100% / 4) repeat;
    pointer-events: none;
  }

  &__logo {
    position: absolute;
    top: 8.596%;
    left: 2.997%;
    width: 14.474%;
    height: auto;
  }

  &__heart {
    position: absolute;
    top: 70.65%;
    left: 46.345%;
    width: 7.237%;
    height: auto;
  }

  &__offer {
    position: absolute;
    top: 50.105%;
    left: 2.997%;
    width: 43.348%;
    height: 41.3%;
    padding: 1.754%;
    background: #fe5000;

    h2 {
      width: 100%;
      margin: 0;
      color: #fff;
      font-family: $fact;
      font-size: clamp(18px, calc(2.339vw - 1.5px), 32px);
      font-weight: 700;
      line-height: clamp(23px, calc(2.632vw - 1.68px), 36px);
      letter-spacing: clamp(-0.3px, -0.022vw, -0.15px);
      text-transform: uppercase;
    }
  }

  &__actions {
    display: flex;
    gap: 2.202%;
    margin-top: 4.404%;
  }

  &__button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35.413%;
    height: auto;
    aspect-ratio: 193 / 52;
    padding: 0 1.5%;
    border: 1px solid #fff;
    border-radius: clamp(2px, 0.293vw, 4px);
    color: #fff;
    font-family: $fact;
    font-size: clamp(10px, calc(1.17vw - 0.75px), 16px);
    font-weight: 500;
    line-height: clamp(13px, calc(1.462vw - 0.94px), 20px);
    text-align: center;
    white-space: nowrap;
    transition: background-color 0.2s ease, color 0.2s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.12);
    }

    &--primary {
      width: 29.908%;
      aspect-ratio: 163 / 52;
      border-color: #e1e7ed;
      background: #e1e7ed;
      color: #171919;

      &:hover {
        background: #f2f2f2;
      }
    }
  }
}

.home-notifications {
  position: fixed;
  right: 40px;
  bottom: 20px;
  z-index: 100;
}

@include display-less(tablet) {
  .home-hero {
    width: 100%;
    padding: 139px 16px 197px;

    &__heading {
      font: 700 48px/48px $roboto;
      letter-spacing: -1.1px;
    }

    &__subheading {
      max-width: 282px;
      margin-top: 24px;
      font: 400 14px/14px $roboto;

      br {
        display: none;
      }
    }
  }

  .home-links {
    flex-direction: column;
    gap: 12px;
    width: 100%;
    margin-top: 40px;

    &__btn {
      width: 100%;
      height: 52px;
    }
  }

  .mission {
    padding: 40px 16px;

    &__content {
      gap: 40px;
      width: 100%;
    }

    &__title {
      font-size: 14px;
      line-height: 1;
    }

    &__text {
      max-width: 328px;
      font-size: 20px;
      line-height: 24px;
    }

    &__desktop-break {
      display: none;
    }
  }

  .fitlab-section {
    height: auto;
    padding: 44px 0;
  }

  .fitlab-banner {
    width: calc(100% - 16px);
    max-width: 344px;
    height: auto;
    aspect-ratio: 344 / 588;
    border-radius: 8px;
    background: #bfa98e;

    &__photo {
      top: 0;
      left: 0;
      width: 100%;
      height: 70.748%;
      background-image: url("../assets/images/fitlab/academy-banner-mobile.webp");
      background-position: center;
    }

    &__grid {
      top: 3.401%;
      left: 4.07%;
      width: 92.151%;
      height: 94.218%;
      background-size: calc(100% / 4) calc(100% / 7);
    }

    &__logo {
      top: 3.571%;
      left: 4.36%;
      width: 34.884%;
    }

    &__heart {
      top: 43.878%;
      left: 4.36%;
      width: 22.674%;
    }

    &__offer {
      top: 57.313%;
      left: 4.36%;
      width: 91.279%;
      height: 40.306%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 12px;
      padding: 16px;

      h2 {
        font-size: 24px;
        line-height: 24px;
        letter-spacing: 0;
      }
    }

    &__actions {
      flex-direction: column;
      gap: 8px;
      height: 104px;
      margin-top: 0;
    }

    &__button {
      width: 100%;
      min-height: 48px;
      max-height: 48px;
      aspect-ratio: auto;
      border-color: #c7d0d8;
      border-radius: 6px;
      font-size: 16px;
      line-height: 20px;
      text-transform: none;

      &--primary {
        width: 100%;
        min-height: 48px;
        max-height: 48px;
        aspect-ratio: auto;
        border-color: #e0e7ee;
        background: #e0e7ee;
      }
    }
  }

  .home-notifications {
    right: 9px;
    max-height: 600px;
  }
}
</style>
